module.exports = __webpack_public_path__ + "static/media/1hike2beer-mockup.eb884f6a.png";